var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"study",class:_vm.classObject,style:(_vm.styleObject),on:{"click":_vm.handleClick}},[_c('span',[_vm._v(" ... you ... have great potential ... "),_c('br'),_c('br'),_vm._v(" Cost: "+_vm._s(_vm.format(-_vm.enslavedTT))+" Time Theorems ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }